import styled from '@emotion/styled'

import { spacing } from 'main/ui'
import { tourBadgeHeight, tourBadgeWidth } from '../common/UpcomingEventBadge'

export const BookmarkContainer = styled.div`
  margin: ${spacing.majorScale(1)}px ${spacing.majorScale(1)}px;
  align-items: start;
  display: flex;
  flex-direction: column;
`

export const Clickable = styled.div`
  cursor: pointer;
`

export const PhotoContainer = styled.div`
  max-height: 130px;
  min-width: 100px;
  position: relative;
  width: 100px;
`

export const UpcomingGatheringEventContainer = styled.div`
  left: ${spacing.majorScale(1)}px;
  position: absolute;
  top: ${spacing.majorScale(1)}px;
`

export const UpcomingTourEventContainer = styled.div`
  left: 50%;
  margin-left: ${-tourBadgeHeight / 2}px;
  margin-top: ${-tourBadgeWidth / 2}px;
  position: absolute;
  top: 50%;
`

export const InfoContainer = styled.div`
  margin: ${spacing.majorScale(1)}px 0;
  margin-left: ${spacing.minorScale(2)}px;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: hidden;
  white-space: nowrap;
`

export const SubInfoContainer = styled.div`
  display: flex;
  flex-direction: row;
`

export const NameContainer = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
`

export const CalloutLayout = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: left;
`
